module.exports = ".notification-wrapper {\n  position: fixed;\n  width: 300px;\n  z-index: 9999;\n}\n.notification-wrapper.left {\n  left: 20px;\n}\n.notification-wrapper.top {\n  top: 20px;\n}\n.notification-wrapper.right {\n  right: 20px;\n}\n.notification-wrapper.bottom {\n  bottom: 20px;\n}\n@media (max-width: 340px) {\n  .notification-wrapper {\n    width: auto;\n    left: 20px;\n    right: 20px;\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/notification/notification.component.less
// module id = ./src/app/components/common/notification/notification.component.less
// module chunks = main